import React from 'react';
import { Badge } from "@/components/ui/badge";
import { Archive } from 'lucide-react';
import { Link } from 'react-router-dom';
import { createPageUrl } from '@/utils';

export default function ArchivedParentBadge({ parentType, parentName, parentPage }) {
  return (
    <Link to={createPageUrl(parentPage)}>
      <Badge 
        variant="outline" 
        className="bg-amber-500/10 text-amber-400 border-amber-500/30 hover:bg-amber-500/20 transition-colors cursor-pointer"
      >
        <Archive className="w-3 h-3 mr-1" />
        Parent {parentType} Archived: {parentName}
      </Badge>
    </Link>
  );
}